import React, { useContext, useReducer } from "react";
import axios from "axios";
import CampaignContext from "./CampaignContext";
import CampaignReducer from "./CampaignReducer";
import {
  FACEBOOK_CAMPAIGN_FORM_DETAILS,
  FACEBOOK_CAMPAIGN_FORM_ERROR,
  FACEBOOK_CAMPAIGN_ID,
  FACEBOOK_CAMPAIGN_ERROR,
} from "../../types";

// Contexts
// import AuthContext from "../../auth/AuthContext";
import LayoutContext from "../../layout/LayoutContext";
import DashboardContext from "../../facebook_profiles/dashboard/DashboardContext";

const CampaignState = (props) => {
  const default_form = {
    name: "",
    special_ad_categories: [],
    daily_budget: 0.0,
    status: "",
    objective: "",
    bid_strategy: "",
  };

  const default_error = {
    name: "",
    special_ad_categories: "",
    daily_budget: "",
    status: "",
    objective: "",
    bid_strategy: "",
  };

  const initialState = {
    list_delivery: ["ALL", "ACTIVE", "PAUSED", "DELETED", "ARCHIVED"],
    list_special_ad: [
      "NONE",
      "EMPLOYMENT",
      "HOUSING",
      "CREDIT",
      "ISSUES_ELECTIONS_POLITICS",
    ],
    list_status: ["ACTIVE", "PAUSED", "DELETED", "ARCHIVED"],
    list_objective: [
      "APP_INSTALLS",
      "BRAND_AWARENESS",
      "CONVERSIONS",
      "EVENT_RESPONSES",
      "LEAD_GENERATION",
      "LINK_CLICKS",
      "LOCAL_AWARENESS",
      "MESSAGES",
      "OFFER_CLAIMS",
      "OUTCOME_LEADS",
      "PAGE_LIKES",
      "POST_ENGAGEMENT",
      "PRODUCT_CATALOG_SALES",
      "REACH",
      "STORE_VISITS",
      "VIDEO_VIEWS",
    ],
    list_bid: ["LOWEST_COST_WITHOUT_CAP", "LOWEST_COST_WITH_BID_CAP"],
    form_details: default_form,
    form_errors: default_error,
    campaign_id: null,
    campaign_error: null,
  };

  const [state, dispatch] = useReducer(CampaignReducer, initialState);
  // const { user } = useContext(AuthContext);
  const { setLoading, setAlert } = useContext(LayoutContext);
  const { setDisplayContent } = useContext(DashboardContext);

  const setFormDetails = (details) => {
    dispatch({
      type: FACEBOOK_CAMPAIGN_FORM_DETAILS,
      payload: details,
    });
  };

  const setFormErrors = (errors) => {
    dispatch({
      type: FACEBOOK_CAMPAIGN_FORM_ERROR,
      payload: errors,
    });
  };

  const resetForm = () => {
    dispatch({
      type: FACEBOOK_CAMPAIGN_FORM_DETAILS,
      payload: default_form,
    });
    dispatch({
      type: FACEBOOK_CAMPAIGN_FORM_ERROR,
      payload: default_error,
    });
  };

  const createCampaign = async (profile_id, ad_account) => {
    setLoading(true);
    const details = JSON.parse(JSON.stringify(state.form_details));

    details.daily_budget = parseFloat(
      parseFloat(parseFloat(details.daily_budget) * 100).toFixed(2)
    );

    details["profile_id"] = profile_id;
    details["ad_account"] = ad_account;

    try {
      const res = await axios.post(
        "/api/facebook_campaign/createCampaign",
        details
      );

      if (res.data.campaign_id) {
        dispatch({
          type: FACEBOOK_CAMPAIGN_ID,
          payload: res.data.campaign_id,
        });
        setDisplayContent("Ad Set");
        resetForm();
      }

      if (res.data.error) {
        setAlert(res.data.error.message, "error");
      }
    } catch (err) {
      dispatch({
        type: FACEBOOK_CAMPAIGN_ERROR,
        payload: err.response,
      });
    }

    setLoading(false);
  };

  return (
    <CampaignContext.Provider
      value={{
        list_delivery: state.list_delivery,
        list_special_ad: state.list_special_ad,
        list_status: state.list_status,
        list_objective: state.list_objective,
        list_bid: state.list_bid,

        form_details: state.form_details,
        form_errors: state.form_errors,
        campaign_id: state.campaign_id,
        // campaign_error: state.campaign_error,
        setFormDetails,
        setFormErrors,
        resetForm,
        createCampaign,
      }}
    >
      {props.children}{" "}
    </CampaignContext.Provider>
  );
};

export default CampaignState;
